import * as R from 'ramda';

export const getReturn = ({ dataSources: { analyzeRiskReturn } }) => {
  return R.prop('return', analyzeRiskReturn) / 100;
};

export default { getReturn };
